import getRows from '../utils/getRows'
import { useEffect } from 'react'

interface useInitDevicesProps {
  setRows: Function
  setDeleteEntryId: Function
  setShowModal: Function
  setShowOverlay: Function
  filter?: {} | null
  currentCustomer?: {} | null
}

const useInit = (props: useInitDevicesProps) => {
  useEffect(() => {
    getRows({
      setDeleteEntryId: props.setDeleteEntryId,
      setShowModal: props.setShowModal,
    })
    .then((data: any) => {
      props.setRows(data)
      props.setShowOverlay(false)
    })
  }, [props.filter, props.currentCustomer])
}

export default useInit
